import gql from 'graphql-tag';

import { MockExamResultFragment, MyMockExamResultFragment } from './fragments/MockExamFragment';

export const queryMyMockExamOverview = gql`
  query myMockExamOverview($examCardId: ID!, $mockExamId: ID!) {
    mockExamResult(mockExamId: $mockExamId) {
      id
      ...MockExamResultFragment
    }

    myMockExamResult(examCardId: $examCardId) {
      id
      ...MyMockExamResultFragment
    }
  }
  ${MockExamResultFragment}
  ${MyMockExamResultFragment}
`;

export const queryMyMockExamHistory = gql`
  query mockExamHistory($mockExamId: ID!) {
    mockExamResult(mockExamId: $mockExamId) {
      ...MockExamResultFragment
    }
  }
  ${MockExamResultFragment}
`;

const ExamSmallDetailFragment = gql`
  fragment ExamSmallDetailFragment on MockExam {
    id
    title
    subjectCode
    iconUrl
    examDate
    status
  }
`;

const ExamHistoryFragment = gql`
  fragment ExamHistoryFragment on MockExam {
    id
    relatedExam {
      officialHistory {
        examId
        examHistoryTitle
      }
    }
  }
`;

export const queryExamCardDetail = gql`
  query examCardDetail($examCardId: ID!) {
    myMockExamCard(examCardId: $examCardId) {
      id
      examId
      seat
      firstName
      lastName
      room
      exam {
        id
        ...ExamSmallDetailFragment
        ...ExamHistoryFragment
      }
      examStartDate
      examEndDate
    }
  }
  ${ExamSmallDetailFragment}
  ${ExamHistoryFragment}
`;

export const getMyMockExamList = gql`
  query myMockExamList {
    myMockExamList {
      id
      examRounds {
        id
        roundCode
        title
        isActive
        examCards {
          id
          examId
          exam {
            id
            ...ExamSmallDetailFragment
          }
        }
      }
    }
  }
  ${ExamSmallDetailFragment}
`;

export const getMyMockExamResults = gql`
  query myMockExamResults($examCardIds: [ID]!, $mockExamIds: [ID]!) {
    myMockExamResults(examCardIds: $examCardIds) {
      id
      examId
      examCardId
      score
      rank
      percentile
    }
    mockExamResults(mockExamIds: $mockExamIds) {
      id
      examId
      fullScore
      averageScore
      examAttendee
    }
  }
`;

export const getExamAssets = gql`
  query examAsset($mockExamId: ID!) {
    mockExamAsset(mockExamId: $mockExamId) {
      id
      questionPapers {
        id
        title
        url
      }
      solutionPapers {
        id
        title
        url
      }
    }
  }
`;

export const MASTER_EXAM_STATUS = {
  NEW: 'NEW',
  KEY_READY: 'KEY_READY',
  GRADE_READY: 'GRADE_READY',
};
